import React from "react";
import "../../assets/css/Common.css";
import * as Constants from "../../constants/Constants";
import * as LocalConstants from "../../constants/FieldConstants";
import { MACYS_LOGO, USER_ICON } from "../../assets/js/image";
import Cookie from "js-cookie";
import { Dropdown } from "react-bootstrap";
import MainNavigation from "./MainNavigation/MainNavigation";
import DeploymentWarning from "./DeploymentWarning/DeploymentWarning";
import { logout } from "../../utils/AuthUtility";

const Header = (props) => {
  return (
    <div>
      <DeploymentWarning />
      {Cookie.get("userName") !== null && (
        <div>
          <div className="headerMain">
            <div className="logoMain col-md-8">
              <MACYS_LOGO
                style="macysLogo"
                id={LocalConstants.macysLogoId}
                altText={Constants.LOGO_ALT_TEXT}
              ></MACYS_LOGO>
              <label
                className="logoTextStyle"
                id={LocalConstants.macysLogoText}
              >
                {Constants.TITLE}
              </label>
            </div>

            <div className="user-account">
              <Dropdown style={{ display: "flex" }}>
                <div className="welcome-name">
                  <span>Hi,</span>&nbsp;
                  <label id={LocalConstants.userId}>
                    {Cookie.get("userName")}
                  </label>
                </div>
                <Dropdown.Toggle id="dropdown-basic" className="userIcon">
                  <USER_ICON
                    style=""
                    id={LocalConstants.userIconId}
                  ></USER_ICON>
                </Dropdown.Toggle>
                <Dropdown.Menu className="logout-dd">
                  <label
                    className="userName displayNone"
                    id={LocalConstants.userId}
                  >
                    Welcome {Cookie.get("userName")}
                  </label>
                  <Dropdown.Item onClick={() => logout(true)}>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <MainNavigation />
        </div>
      )}
    </div>
  );
};

export default Header;
